"use client";
import React from "react";

export default function FeaturesStats({data}) {
    const {
        title,
        subtitle,
        layout,
        columns = 3,
        align = "center",
        features = [],
        background = {},
        extra = {}
    } = data || {};

    const bgStyle =
        background.type === "color"
            ? {backgroundColor: background.value}
            : background.type === "gradient"
                ? {backgroundImage: background.value}
                : background.type === "image"
                    ? {
                        backgroundImage: `url(${background.value})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center"
                    }
                    : {};

    const textAlignClass =
        align === "left"
            ? "text-left items-start"
            : align === "right"
                ? "text-right items-end"
                : "text-center items-center";

    const gridCols =
        columns === 2
            ? "grid-cols-2"
            : columns === 4
                ? "grid-cols-2 md:grid-cols-4"
                : "grid-cols-1 sm:grid-cols-3";

    return (
        <section className={`py-16`} style={bgStyle}>
            <div className="max-w-6xl mx-auto px-4">
                <div className={`mb-10 flex flex-col ${textAlignClass}`}>
                    {title && <h2 className="text-3xl font-bold">{title}</h2>}
                    {subtitle && <p className="text-gray-500 mt-2">{subtitle}</p>}
                </div>

                <div className={`grid gap-8 ${gridCols}`}>
                    {features.map((stat, i) => (
                        <div key={i} className="flex flex-col items-center">
                            <div className="text-4xl font-extrabold">{stat.title}</div>
                            <div className="text-sm text-gray-500 mt-1">{stat.description}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}